import React from 'react'
import './index.sass'

export default function ConnectionCard({ type, isActive, img, page }) {
    const opennewtab = () => {
        console.log(type, " type")
        if (type == 'website') {
           window.open(`https://${page}`, img.split(".")[0])
        }else{
            window.open(`https://${type}.com/${page}`)
        }
    }
    return (
        <div className="profile-connection-widget" onClick={opennewtab}>
            <img className={`${isActive ? 'profile-connection-w-cover' : 'profile-connection-w-cover-gray'}`} alt={type} src={require(`../../assets/img/${img}`)} />
            {isActive ? <img className="profile-clink" src={require('../../assets/icons/clink.svg')} alt={type} /> : <div></div>}
        </div>
    )
}
